import type { CropperProps, CropperRef } from "react-advanced-cropper";
import { Cropper } from "react-advanced-cropper";
import { twMerge } from "tailwind-merge";

import "react-advanced-cropper/dist/style.css";

export type ImageEditorProps = CropperProps;

export function ImageEditor({ ref: reference, ...props }: { ref: React.RefObject<CropperRef> } & ImageEditorProps) {
	return (
		<Cropper
			{...props}
			className={twMerge(
				"aspect-square w-full rounded border",
				props.className
			)}
			ref={reference}
		/>
	);
}
